// extracted by mini-css-extract-plugin
export var deleteModal = "_gl-0";